import React from 'react';
import {
  BasicFormModalLayout,
  SaveStandardAreaInstallationForm
} from 'modules';

export type SaveStandardAreaInstallationModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveStandardAreaInstallationModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save standard area installation'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveStandardAreaInstallationForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
